
import { Component, Vue, Ref } from 'vue-property-decorator'
import { PersonService } from '@/services'
import InterviewTable from './components/interview_table.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import FullLoading from '@/components/full_loading/index.vue'

@Component({
    name: 'interviews',
    components: {
        InterviewTable,
        ScrollTo,
        FullLoading
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private interviews = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private isLoading = false
    private loadingText = ''
    private status = 1
    private statusOptions = [
        { label: '待回复', value: 1 },
        { label: '已同意', value: 2 },
        { label: '已拒绝', value: 3 }
    ]


    private async mounted() {
        this.showLoading()
        await this.getInterviews()
        this.hideLoading()
    }

    /** 获取采访列表 */ 
    private async getInterviews() {
        const status = this.status === -1 ? undefined : this.status
        const params = {
            status: status,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await PersonService.getInterviews(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.interviews = result.data.list
        }
    }   

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getInterviews)
    }

    private showLoading() {
        this.isLoading = true
    }

    private hideLoading() {
        this.isLoading = false
    }
}
